import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";
import Cookies from "js-cookie";


const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION === "true";


export const getAboutUs = async (data) => {
  try {
    const access_token = Cookies.get("access_token") || isLoggedIn();
 
    const payload = {
      ...data,
    };
 
    // ✅ API expects ?path=/about-us
    const response = await axios.get("/page-details", { params: payload });
    return response.data;
  } catch (err) {
    console.error("AboutUs API Error:", err);
    throw err;
  }
}; 
